<template>
  <div v-if="store.backgroundTasks.length > 0" class="bg-task-container">
    <div v-for="task in store.backgroundTasks" :key="task.id" class="bg-task-toast" :class="task.status">
      <span v-if="task.status === 'running'" class="bg-task-spinner"></span>
      <span v-else-if="task.status === 'done'" class="bg-task-check">&#10003;</span>
      <span v-else-if="task.status === 'error'" class="bg-task-error-icon">&#10007;</span>

      <div class="bg-task-content">
        <router-link v-if="task.status === 'done' && task.type === 'ai-convert' && task.result"
          :to="`/account-forms/${task.result.id}/edit`" class="bg-task-link">
          {{ task.label }}
        </router-link>
        <span v-else class="bg-task-label">{{ task.label }}</span>
        <span v-if="task.message" class="bg-task-message">{{ task.message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store'

export default {
  name: 'BackgroundTaskIndicator',
  data() {
    return { store }
  }
}
</script>

<style scoped>
.bg-task-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 340px;
}

.bg-task-toast {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.08);
  animation: bg-task-slide-in 0.25s ease-out;
  line-height: 1.4;
}

.bg-task-toast.running {
  border-left: 3px solid var(--color-primary, #3a71fb);
}

.bg-task-toast.done {
  border-left: 3px solid #16a34a;
}

.bg-task-toast.error {
  border-left: 3px solid #dc2626;
}

.bg-task-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #e5e7eb;
  border-top-color: var(--color-primary, #3a71fb);
  border-radius: 50%;
  animation: bg-task-spin 0.6s linear infinite;
  flex-shrink: 0;
  margin-top: 2px;
}

.bg-task-check {
  color: #16a34a;
  font-size: 1rem;
  font-weight: bold;
  flex-shrink: 0;
  margin-top: 1px;
}

.bg-task-error-icon {
  color: #dc2626;
  font-size: 1rem;
  font-weight: bold;
  flex-shrink: 0;
  margin-top: 1px;
}

.bg-task-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.bg-task-label {
  color: #374151;
  word-break: break-word;
}

.bg-task-link {
  color: var(--color-primary, #3a71fb);
  text-decoration: none;
  word-break: break-word;
  cursor: pointer;
}

.bg-task-link:hover {
  text-decoration: underline;
}

.bg-task-message {
  color: #9ca3af;
  font-size: 0.75rem;
  word-break: break-word;
}

@keyframes bg-task-spin {
  to { transform: rotate(360deg); }
}

@keyframes bg-task-slide-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* z-index 10000 puts these toasts above the bottom bar, so they must be
   lifted rather than relying on stacking. */
@media screen and (max-width: 700px) {
  .bg-task-container {
    bottom: calc(20px + var(--app-mobile-nav-total));
  }
}
</style>
